<script>
import { prop, propOr } from 'ramda'

import { propValidator, PROP_TYPES } from '@/utils/validators'
import {
  ERROR_HANDLER,
  getErrorSettingsByBackendError,
  HTTP_STATUS_CODE
} from 'enums/errorCodes'
import { MODAL } from '@/components/_modals/AModalWrapper'
import {
  ACTIVATOR_ID,
  ACTIVATOR_SELECTOR_BY_ACTIVATOR_ID
} from 'enums/activator-id'
import { AUTH_TYPE, COMPONENT_BY_AUTH_TYPE } from 'enums/auth'

export default {
  name: 'AErrorMessage',
  props: {
    error: propValidator([PROP_TYPES.ERROR, PROP_TYPES.OBJECT], false),
    hideTimeout: propValidator([PROP_TYPES.NUMBER], false, 5000),
    bold: propValidator([PROP_TYPES.BOOLEAN], false, false),
    scrollToMessage: propValidator([PROP_TYPES.BOOLEAN], false, false)
  },
  data() {
    return {
      message: '',
      isErrorMessageVisible: false
    }
  },
  computed: {
    messageClasses() {
      return ['error-msg', { 'error-msg--bold': this.bold }]
    }
  },
  watch: {
    error: {
      immediate: true,
      deep: true,
      handler(val) {
        if (!val) {
          this.message = ''
          this.isErrorMessageVisible = false
          return
        }

        this.showError(val)
      }
    }
  },
  methods: {
    isHideErrorMessage(code, error) {
      const isInternalServerError =
        getErrorSettingsByBackendError(error).status ===
        HTTP_STATUS_CODE.INTERNAL_SERVER_ERROR

      return (!code || isInternalServerError) && !prop('message', error)
    },
    getErrorMessage(code, error) {
      return propOr(
        '',
        'message',
        code ? getErrorSettingsByBackendError(error) : error
      )
    },
    async showError(error) {
      const code = this.$helper.getBackendErrorCode(error)

      if (this.isHideErrorMessage(code, error)) return

      this.message = this.getErrorMessage(code, error)
      this.isErrorMessageVisible = true

      this.hideMessageWithDelay(this.hideTimeout)

      await this.$nextTick()
      if (this.scrollToMessage) {
        this.$scrollTo('.error-msg', { offset: -screen.height / 2 })
      }
    },
    hideMessageWithDelay(delay) {
      if (delay == null) return

      setTimeout(() => {
        this.message = ''
        this.isErrorMessageVisible = false
      }, delay)
    },
    [ERROR_HANDLER.OPEN_SIGN_IN_WINDOW]() {
      this.$helper.openModal(MODAL.AUTH_FORM, {
        activeComponent: COMPONENT_BY_AUTH_TYPE[AUTH_TYPE.SIGN_UP],
        activatorSelector: ACTIVATOR_SELECTOR_BY_ACTIVATOR_ID[ACTIVATOR_ID.AUTH]
      })
    },
    createComponent(h, string) {
      const hasHandler = !!string.match(/^#.+#$/g)

      if (!hasHandler) {
        return h('span', { domProps: { innerHTML: string } })
      } else {
        const settings = string.match(/{[^{^}]+}/g)

        const text = settings[0].replace(/[{}]/g, '')
        const handler = settings[1].replace(/[{}]/g, '')

        return h('span', { class: 'handler', on: { click: this[handler] } }, [
          text
        ])
      }
    }
  },
  render(h) {
    if (!this.isErrorMessageVisible) return null

    const regExp = /([^{}#]+)|(#{[^{]+[^}]+}#)/gm
    const stringArray = this.message.match(regExp) || []

    const components = stringArray.map(string =>
      this.createComponent(h, string)
    )

    const message = h('div', { class: this.messageClasses }, components)

    return h('collapse-transition', [message])
  }
}
</script>

<style lang="scss" scoped>
.error-msg {
  font-size: 12px;
  height: 20px;
  line-height: 20px;
  color: #d46161;
  font-weight: 500;

  &--bold {
    font-weight: 600;
  }

  .handler {
    font-weight: 700;
    color: $c--main;
    cursor: pointer;
  }
}
</style>
